export default "__VITE_ASSET__CKG0rIYZ__"